import { Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Container, Row } from "react-bootstrap";
import { useAuthState } from "../../context/AuthContext";
import { ModalDlgConfirm } from "../../components/common";
import { AccountFormRoler } from "../../components/account/AccountForm";
import { updateUser } from "../../lib/api/user";

// ---------------------------------------------------------------
//
//  Header Component
//
// ---------------------------------------------------------------
const HeaderComponent = ({ user }) => {
  return (
    <Fragment>
      <Form.Group controlId="userAlias">
        <Form.Label>사용자 별칭</Form.Label>
        <Form.Control type="text" value={user.alias} disabled />
      </Form.Group>
      <Form.Group controlId="userName">
        <Form.Label>사용자 아이디</Form.Label>
        <Form.Control type="text" value={user.name} disabled />
      </Form.Group>
    </Fragment>
  );
};

// ---------------------------------------------------------------
//
//  Password Component
//
// ---------------------------------------------------------------
const PasswordComponent = ({
  user,
  handlePassword,
  handleNewPassword,
  handleNewPassword2,
}) => {
  return (
    <Fragment>
      <hr />
      <Row className="mt-2">
        <Form.Label>비밀 번호</Form.Label>
        <Row className="m-2">
          {user.roler === "admin" ? (
            <Form.Group controlId="password">
              <Form.Label>현재 비밀번호</Form.Label>
              <Form.Control
                onChange={handlePassword}
                type="password"
                placeholder="password"
                required
              />
              <Form.Control.Feedback type="invalid" className={"float-left"}>
                비밀번호를 입력해주세요!
              </Form.Control.Feedback>
            </Form.Group>
          ) : null}

          <Form.Group controlId="new-password">
            <Form.Label>새로운 비밀번호</Form.Label>
            <Form.Control
              onChange={handleNewPassword}
              type="password"
              placeholder="new password"
              // required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="confirm-new-password">
            <Form.Label>새로운 비밀번호 확인</Form.Label>
            <Form.Control
              onChange={handleNewPassword2}
              type="password"
              placeholder="confirm new password"
              // required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Row>
      <hr />
    </Fragment>
  );
};

// ---------------------------------------------------------------
//
//  Home
//
// ---------------------------------------------------------------
const AccountEidt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    loggedUser: { roler },
  } = useAuthState();

  const [user, setUser] = useState({
    id: location.state.user._id,
    alias: location.state.user.displayName,
    name: location.state.user.username,
    roler: location.state.user.roles[0],
    dsUnivId: "",
    dsUnivPw: "",
    dsUnivLink: false,
  });

  const [authForm, setAuthForm] = useState({
    show: false,
    title: "",
  });

  const [dlgConfirm, setDlgConfirm] = useState({
    type: "",
    msg: "",
    show: false,
    handleClose: () => {
      setDlgConfirm({
        ...dlgConfirm,
        show: false,
      });
    },
  });

  const handleDSUnivId = (e) => {
    setUser({ ...user, dsUnivId: e.target.value });
  };

  const handleDSUnivPassword = (e) => {
    setUser({ ...user, dsUnivPw: e.target.value });
  };

  const handleDSUnivSubmit = (e) => {
    const dsUnivLink = !user.dsUnivLink;
    setAuthForm({ ...user, dsUnivLink });
    console.log("user : ", user);
  };

  const handlePassword = (e) => {
    setUser({ ...user, password: e.target.value });
  };

  const handleNewPassword = (e) => {
    setUser({ ...user, new_password: e.target.value });
  };

  const handleNewPassword2 = (e) => {
    setUser({ ...user, new_password2: e.target.value });
  };

  const handleRoler = (e) => {
    const roler = e.target.value;
    const { show, name } =
      roler === "professor"
        ? { show: true, name: "사번" }
        : roler === "student"
        ? { show: true, name: "학번" }
        : { show: false, name: "" };

    setUser({ ...user, roler });
    setAuthForm({ ...authForm, show, name });
  };

  const handleSubmit = async (e) => {
    console.log("AccoutForm handleSubmit");

    const form = e.currentTarget;
    const resultValidity = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();

    if (!resultValidity) {
      console.log("AccoutForm resultValidity failed");
      return;
    }
    console.log("AccoutForm updateAccout");
    const { status, message } = await updateUser({
      id: user.id,
      roles: [user.roler], // 역할이 배열
      dsUnivLink: user.dsUnivLink,
      password: user.password,
      new_password: user.new_password,
      new_password2: user.new_password2,
    });

    setDlgConfirm({
      ...dlgConfirm,
      type: "info",
      msg: message,
      show: true,
    });
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className="AccountEidt">
      <Container fluid="md">
        <br />
        <Form onSubmit={handleSubmit}>
          <HeaderComponent user={user} />
          <PasswordComponent
            user={user}
            handlePassword={handlePassword}
            handleNewPassword={handleNewPassword}
            handleNewPassword2={handleNewPassword2}
          />
          <AccountFormRoler
            isAdmin={roler === "admin"}
            roler={user.roler}
            authForm={authForm}
            handleRoler={handleRoler}
            handleDSUnivId={handleDSUnivId}
            handleDSUnivPassword={handleDSUnivPassword}
            handleDSUnivSubmit={handleDSUnivSubmit}
          />
          <br />
          <Button className="btn-lg" variant="primary" type="submit">
            저장
          </Button>
          <Button
            className="btn-lg ms-3"
            variant="info"
            type="button"
            onClick={handleClose}
          >
            확인
          </Button>
        </Form>
      </Container>
      <ModalDlgConfirm
        show={dlgConfirm.show}
        handleClose={dlgConfirm.handleClose}
        type={dlgConfirm.type}
        msg={dlgConfirm.msg}
      />
    </div>
  );
};

export default AccountEidt;
